/**
 * Determines if an element is fully visible in the current viewport
 * @param {HTMLElement} el - HTML element
 * @returns {Boolean}
 */
function isElementInViewport(el) {
  const rect = el.getBoundingClientRect()

  const result =
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)

  return result
}

/**
 * Creates and returns a debounced version of the passed function which
 * will postpone its execution until after wait milliseconds have elasped since
 * last invoked
 * @param {Function} func - Function to debounce
 * @param {Number} wait - Duration to wait in milliseconds
 * @returns {Function}
 */
function debounce(func, wait = 100) {
  let timeout
  return function (...args) {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.apply(this, args)
    }, wait)
  }
}

/**
 * Creates a new date that is the result of adding a specified number of hours to a date
 * @param {Date} date - Date object
 * @param {Number} hours - Hours to add to the date
 * @returns {Date}
 */
function addHoursToDate(date, hours) {
  const result = new Date(date.getTime() + hours * 60 * 60 * 1000)
  return result
}

export { isElementInViewport, debounce, addHoursToDate }
